import { GetGlobalBus } from "../@core/@models/globals";

export const TIPO_COMPROMISO_PAGO_EUROPAFACTOR: number = 1268;
export const FACTURA_IMPAGADA_EUROPAFACTOR: number = 1242;
export const FACTURA_PAGADA_EUROPAFACTOR: number = 1247;
export const INSTALLED_LANGUAGES = ['/es', '/en', '/it'];

export function  toogleChatbox(show: boolean): void {
  // Seleccionar todos los elementos con la clase 'chatboxhead'
  const chatboxHeads = document.querySelectorAll('.chatboxhead');
  // Iterar sobre los elementos y ocultarlos
  chatboxHeads.forEach((chatboxHead): void => {
    if (chatboxHead instanceof HTMLElement) {
      if(show){
        chatboxHead.style.display = 'block';
      }else{
        chatboxHead.style.display = 'none';
      }
    }
  });
}

export function removeLanguageUriPrefix(uri: string): string {
  // eslint-disable-next-line @typescript-eslint/prefer-for-of
  for (let i = 0; i < INSTALLED_LANGUAGES.length; i++) {
    const langUri: string = uri.substring(0, INSTALLED_LANGUAGES[i].length).toLowerCase();
    if (langUri === INSTALLED_LANGUAGES[i]) {
      return uri.substring(INSTALLED_LANGUAGES[i].length).toLowerCase();
    }
  }
  return uri;

}
